export const PHOTO_DOCUMENT_TYPE = 'Photos';
export const EXTERNAL_REPORT_NAME = 'EXTERNAL Workorder Inspection Report';
export const INTERNAL_REPORT_NAME = 'INTERNAL Workorder Inspection Report';

// Duplicate uploads get a "(1)", "(2)", ... suffix from the backend, so match on the prefix.
const hasReportNamed = (documents, name) => documents
  .some(doc => !doc.not_use && (doc.document_name || '').indexOf(name) === 0);

export const hasWoInspectionReports = documents =>
  hasReportNamed(documents, EXTERNAL_REPORT_NAME) &&
  hasReportNamed(documents, INTERNAL_REPORT_NAME);

export const woReportPhotos = documents =>
  documents.filter(doc => doc.document_type === PHOTO_DOCUMENT_TYPE && !doc.not_use);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/phaseActionMenu/woReportUtils.js